module.exports = __webpack_public_path__ + "static/humangif-ed3053bf39fb17de52e2521767048303.gif";